import React, { useEffect, useState } from 'react';
import businessTrip from '../../assets/images/work/business_trip/thumbnail.png';
import { Link } from 'react-router-dom';
import '../../styles/global.css';



function HotPick() {
  const works = [
    {
      id: 1,
      link: "/business_trip", 
      thumbnail: businessTrip, 
      title: "出張申請サービス", 
      tags: ["デスクトップUI", "BONO課題＋α", "要件定義", "情報設計"] 
    }
  ];



  return (
    <section id="hotpick">
    <div className="hot-pick-wrapper">
      <h1 className="hot-pick-text section-title">HOT PICK</h1>
    </div>

    <div className="hot-pick-content">
        {works.map((work) => (
                <Link key={work.id} to={work.link} className="hot-pick-link">
                   <div className="hot-pick-content">

                     {/* サムネイル */}
                     <div className="hot-pick-thumbnail">
                      <div className="hot-pick-thumbnail">
                        <img src={work.thumbnail} alt={work.title} />
                      </div>
                     </div>

                     {/* タイトル */}
                     <div className="hot-pick-title">
                        <h2>{work.title}</h2>
                     </div>

                     {/* タグ一覧 */}
                     <ul className="wrapper-tag">
                     {work.tags.map((tag, index) => (
                          <li key={index} className="hot-pick-tag tag">
                            #{tag}
                          </li>
                        ))}

                     </ul>

                   </div>
                </Link>
        ))}

              
    </div>

    </section>


  );

}

export default HotPick;